import { Component, inject, OnInit } from "@angular/core";
import {
  NewUiProgressBarComponent,
  ProgressNotificationService,
  translateSafely,
} from "@ankaadia/ankaadia-shared-frontend";
import { AuthService } from "@auth0/auth0-angular";
import { TranslocoService } from "@jsverse/transloco";
import { BlockUIModule } from "primeng/blockui";
import { CardModule } from "primeng/card";
import { PrimeNG } from "primeng/config";
import { DividerModule } from "primeng/divider";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TabViewModule } from "primeng/tabview";
import { ToastModule } from "primeng/toast";
import { filter } from "rxjs";
import { environment } from "../environments/environment";
import { BillingDataComponent } from "./components/billing-data/billing-data.component";
import { CandidateDataComponent } from "./components/candidate-data/candidate-data.component";
import { ChangeStatisticsComponent } from "./components/change-statistics/change-statistics.component";
import { HeaderComponent } from "./components/header/header.component";
import { KnownVariablesComponent } from "./components/known-variables/known-variables.component";
import { LingokingDataComponent } from "./components/lingoking-data/lingoking-data.component";
import { LoginComponent } from "./components/login/login.component";
import { SalesDataComponent } from "./components/sales-data/sales-data.component";
import { OfficeEnvService } from "./shared/officeEnvService";
import { SettingsService } from "./shared/settings.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  imports: [
    ToastModule,
    HeaderComponent,
    LoginComponent,
    TabViewModule,
    BlockUIModule,
    ProgressSpinnerModule,
    CardModule,
    CandidateDataComponent,
    ChangeStatisticsComponent,
    SalesDataComponent,
    LingokingDataComponent,
    KnownVariablesComponent,
    BillingDataComponent,
    NewUiProgressBarComponent,
    DividerModule,
  ],
})
export class AppComponent implements OnInit {
  notification = inject(ProgressNotificationService);

  clientId: string = environment.auth0_clientId;
  authID: string = environment.auth0_domain;
  graphQL: string = environment.graphqlURI;

  isBusy = false;

  authenticated = false;
  isMasterUser = false;

  isExcel = false;

  readonly language = this.transloco.getActiveLang();

  constructor(
    protected readonly auth0: AuthService,
    private readonly primengConfig: PrimeNG,
    private readonly settings: SettingsService,
    private readonly officeEnvService: OfficeEnvService,
    protected readonly transloco: TranslocoService
  ) {}

  myTranslation(key: string): string {
    return translateSafely(key);
  }

  setBusyState(busyState: boolean): void {
    this.isBusy = busyState;
  }

  ngOnInit(): void {
    this.primengConfig.ripple.set(true);
    this.settings.isAuthenticated$.pipe(filter((x) => x)).subscribe((auth) => (this.authenticated = auth));
    this.settings.isMasterUser$.pipe(filter((x) => x)).subscribe((isMaster) => (this.isMasterUser = isMaster));
    this.isExcel = this.officeEnvService.getHostApplication() === Office.HostType.Excel;
  }
}
